"use strict";
(function () {
  /**
  * Базовое пространство имен.
  * Собственные функции данного пространства доступны сразу, например, raise. 
  * Для запуска программы после инициализации всех компонентов WebAccess служит специальная функция WebAccess.ready().  
  *
  * Для доступа к дочерним пространствам имен, например current или extensions, необходимо сначала дождаться их инициализации. 
  * Если необходимо обеспечить работу лишь с некоторыми из них, можно использовать публичные deferred-объекты, например SideBarInit, ToolBarInit. 
  * @example
  * console.log(WebAccess.current); // Возвратит пустой объект.
  * WebAccess.ready(function() {
  *   console.log("Иницализация завершена");
  *   console.log(this); //this = WebAccess;
  *   console.log(WebAccess.current.toolBar); // Объект панели инструментов полностью инициализирован и заполнен.
  *   console.log(WebAccess.current.sideBar); // Объект боковой панели полностью инициализирован и заполнен.
  * });
  *
  * // Если предполагается работа только с кнопками панели 
  * // инструментов, можно не дожидаться инициализации всех компнентов.
  * $.when(WebAccess.ToolBarInit).done(function () {
  *   console.log("Иницализация завершена");
  *   console.log(WebAccess.current.toolBar); // Объект панели инструментов полностью инициализирован и заполнен.
  *   console.log(WebAccess.current.sideBar); // Может быть пустым и еще не инициализированным.   
  * });
  * @global
  * @namespace WebAccess
  * @alias WA
  */
  var WebAccess = function () {
    var self = this;


    this._whenInitComplete = [];

    /**
     * Обработчик инициализации. Добавляет функцию в очередь на исполнение, когда объектная модель WebAccess готова к использованию.
     *
     * @function WebAccess.ready
     * @param {function} func Ссылка на функцию, которая будет вызвана немедленно по готовности объектной модели к использованию
     * @return {object} Объект WebAccess
     */
    this.ready = function (func) {
      if (!func) {
        WA.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED', 'function');
      } else if (!$.isFunction(func)) {
        WA.raise('ERR_INVALID_PARAMETER_TYPE');
      } else {
        if (WA.Init.state() === 'pending') {
          this._whenInitComplete.push(func);
        } else {
          func.apply(this);
        }

      }
      return this;
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /*
    * Получить расширение файла из URL
    * @private
    * @since 5.2.0.1100
    */
    this._getFileExtensionFromURL = function (url) {
      if (!url) return null;
      if (url.indexOf('.') === -1) return null;
      var parts = url.split("?")[0].split('.');
      return parts[parts.length - 1];
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Динамическая подгрузка ресурсов. 
    * Позволяет подключить сторонний JS файл или таблицу стилей CSS.
    * Загрузка JS-файлов или таблиц стилей CSS происходит синхронно в порядке очереди.
    *
    * @function WebAccess.include
    * @param {string} url Абсолютный или относительный путь к целевому файлу
    * @raise ERR_UNSUPPORTED_TYPE_RESOURCE - Данный тип ресурсов не поддерживается  
    * @return WebAccess
    * @example 
    * // Подключить сторонний файл General.js. 
    * WebAccess.include('/js/Extension.RecordOffice/General.js');
    * // Подключить для соответствующих справочников необходимый файл для исполнения специфической логики их работы.
    *  var refCode = WebAccess.current.getReferenceCode(); 
    *  switch (refCode) { 
    *    case 'РКК' : 
    *      WebAccess.include('/js/Extension.RecordOffice/RRCReference.js'); 
    *      break; 
    *    case 'RRCAssignments': 
    *      WebAccess.include('/js/Extension.RecordOffice/RRCAssignmentsReference.js'); 
    *      break; 
    *    case 'ГДЛ': 
    *      WebAccess.include('/js/Extension.RecordOffice/LogsReference.js'); 
    *      break; 
    *    case 'IndividualUserModuleSettings': 
    *      WebAccess.include('/js/Extension.RecordOffice/IndividualUserModuleSettingsReference.js'); 
    *      break; 
    *  };
    */
    this.include = function (url) {
      var type = this._getFileExtensionFromURL(url);
      switch (type) {
        case "js":
          $.ajaxSetup({ async: false, cache: true });
          $.getScript(url);
          $.ajaxSetup({ async: true, cache: false });
          break;
        case "css":
          var link = document.createElement("link");
          link.setAttribute("rel", "stylesheet");
          link.setAttribute("type", "text/css");
          link.setAttribute("href", url);
          document.getElementsByTagName("head")[0].appendChild(link);
          break;
        default:
          this.raise("ERR_UNSUPPORTED_TYPE_RESOURCE", type);
          break;
      }
      return this;
    };

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

   

    /**
    * Предоставляет доступ к информации о веб-модулях и средства для работы с ними.
    * @namespace WebAccess.extensions
    */
    this.extensions = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Предоставляет инструменты для генерирования динамических компонент. 
    * Например, модальных окон или контекстных меню.
    * Не требует использования функции WebAccess.ready.
    * @namespace WebAccess.components
    * @since 5.0.0.4000 
    */
    this.components = this.CMP = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Предоставляет инструменты для работы с веб-сервисами. 
    * Не требует использования функции WebAccess.ready.
    * @namespace WebAccess.services
    * @alias SRV
    * @since 5.0.0.4000 
    */
    this.services = this.SRV = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Предоставляет инструменты для работы с шаблонами. 
    * Не требует использования функции WebAccess.ready.
    * @namespace WebAccess.templates
    * @alias TMPL
    * @since 5.0.0.4213
    */
    this.templates = this.TMPL = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Предоставляет инструменты для работы с фабриками документов, папкок, задач, заданий, справочников, отчетов и сценариев.
    *
    * @namespace WebAccess.factories
    * @alias TMPL
    * @since 5.0.0.7300
    */
    this.factories = this.FC = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Предоставляет вспомогательные объекты для расширения функциональности классов, например объекты для работы с реквизитами. 
    * Не предназначен для создания самостоятельно используемых объектов. 
    * Не требует использования WebAccess.ready.
    * @namespace WebAccess.mixins
    * @since 5.0.0.7100
    */
    this.mixins = {};


    /**
    * Предоставляет инструменты для работы с кэшем. Не требует использования функции WebAccess.ready.
    * @namespace WebAccess.cache
    * @since 5.0.0.7100
    */
    this.cache = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
   * Предоставляет инструменты для работы с прикладными функциями Is-Builder. Не требует использования функции WebAccess.ready.
   * @namespace WebAccess.isbuilder
   * @since 5.5.0.5500
   */
    this.isbuilder = this.ISB = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Предоставляет инструменты для работы с историей. 
     * Генерирует события изменения стека истории. 
     * 
     * @namespace  WebAccess.history
     */
    this.history = {};

    /**
    * Предоставляет доступ к прикладным методам объектов.
    * @namespace WebAccess.domainMethods
    * @since 5.5.0.1000
    */
    this.domainMethods = {};

    /**
    * Предоставляет доступ к прикладным действиям.
    * @namespace WebAccess.actions
    * @since 5.6.0.1000
    */
    this.actions = {};

    /**
    * Предоставляет информацию о текущем окружении. Например, о версии браузера, об операционной системе, о устройстве.
    * @namespace WebAccess.environment
    * @property {string} ua Строка User-agent
    * @alias ENV
    * @since 5.0.0.4200
    *
    * @example 
    * if (WA.ENV.browser.name == "Firefox") { alert("Текущи браузер Firefox"); }    
    */

    this.environment = this.ENV = window.environmentInfo;

    /**
    * Содержит информацию об имени и версии текущего браузера.
    *
    * @namespace WebAccess.environment.browser    
    * @property {string} name Имя браузера. например, «Firefox»
    * @property {string} major Основная версия текущего браузера, например, «23»
    * @property {string} version Полная версия, например, «23.0»
    *
    * @example 
    * if (WA.ENV.browser.name == "Firefox") { alert("Текущи браузер Firefox"); }    
    */

    /**
    * Содержит информацию об архитектуре используемого процессора.
    *
    * @namespace WebAccess.environment.cpu
    * @property {string} architecture Сборка браузера, например, «amd64»
    */

    /**
    * Содержит информацию об используемом мобильном устройстве.
    *
    * @namespace WebAccess.environment.device
    * @property {string} model Модель устройства
    * @property {string} vendor Поставщик
    * @property {string} type Тип устройства
    */

    /**
    * Содержит информацию о движке браузера.  
    *
    * @namespace WebAccess.environment.engine
    * @property {string} name Имя движка, например, «Gecko»  
    * @property {string} version Полная версия, например, «23.0»
    */

    /**
    * Содержит информацию об используемой операционной системе.
    * @namespace WebAccess.environment.os
    * @property {string} name Имя операционной системы, например «Windows»   
    * @property {string} version Версия, например «8»
    */

    this.environment.isMobile = function () {
      var agent = navigator.userAgent.toLowerCase();
      var oldMobileBrowser = (agent.indexOf("series60") != -1) || (agent.indexOf("symbian") != -1) || (agent.indexOf("windows ce") != -1) || (agent.indexOf("blackberry") != -1);
      var modernMobile = typeof orientation != 'undefined' ? true : false;
      return oldMobileBrowser || modernMobile;
    };

    this.environment.isAndroid = function () {
      return self.environment.os.name === "Android";
    }

    this.environment.isIOS = function () {
      return self.environment.os.name === "iOS";
    }

    this.environment.isTouch = function () {
      var agent = navigator.userAgent.toLowerCase(); //todo: закешировать уже
      // If touch events are defined we are in a modern touch screen OS            
      return ('ontouchstart' in document.documentElement) ? true : false || agent.indexOf("touch") !== -1 || agent.indexOf("tablet") !== -1;
    };

    /**
    * Ориентация экрана.
    */
    this.environment.isVertical = function () {
      if (($(window).height() / $(window).width()) > 1) return true;
      else return false;
    };

    /**
    * Платформа.
    * 
    * @deprecated 
    */
    this.environment.platform = "unknown"
    if (navigator.appVersion.indexOf("Win") != -1) this.environment.platform = "windows";
    if (navigator.appVersion.indexOf("Mac") != -1) this.environment.platform = "macos";
    if (navigator.appVersion.indexOf("Linux") != -1 || navigator.appVersion.indexOf("X11") != -1) this.environment.platform = "linux";

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * deferred-объект. Сообщает о готовности к использованию клиентской объектной модели после ее полной инициализации.
    *
    * @member WebAccess.Init
    */
    this.Init = $.Deferred();

    /**
    * deferred-объект. Сообщает о готовности к использованию пространства имен WebAccess.current.sideBar после его полной инициализации.
    * При использовании WebAcces.ready функция будет исполнена несколько позже, 
    * так как функция WeabAcces.ready дожидается полной инициализации всех deferred-объектов и только потом исполняет переданную ей функцию.
    *
    * @member WebAccess.SideBarInit
    *
    * @example
    * $.when(WebAccess.SideBarInit).done(function () {
    *  WebAccess.current.sideBar.tabs.create("FilterRRC").enable().setLabel(L("RRC_FILTER")).setIcon("SidebarAndExtensions/EDocumentSearch_24.png").setHtml(createFilterTabs("РКК"));
    *  WebAccess.current.sideBar.tabs.create("FilterRRCAssignment").enable().setLabel(L("RRC_ASSIGNMENTS_FILTER")).setIcon("SidebarAndExtensions/EDocumentSearch_24.png").setHtml(createFilterTabs("RRCAssignments"));
    * });
    */
    this.SideBarInit = $.Deferred();
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * deferred объект. Сообщает о готовности к использованию пространства имен WebAccesst.agent после его полной инициализации.
    * @since 5.1.0.1500
    * @member WebAccess.AgentInit 
    */
    this.AgentInit = $.Deferred();
   

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * deferred объект. Сообщает о готовности к использованию пространства имен WebAccess.current.toolBar после его полной инициализации.
    * @member WebAccess.ToolBarInit
    */
    this.ToolBarInit = $.Deferred();
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * deferred объект. Сообщает о готовности к использованию пространства имен WebAccess.current.form.controls после его полной инициализации.
    * @member WebAccess.FormControlsInit
    */
    this.FormControlsInit = $.Deferred();
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * deferred объект. Сообщает о готовности к использованию пространства имен WebAccess.current.details после его полной инициализации.
    * @member WebAccess.DetailsInit
    */
    this.DetailsInit = $.Deferred();
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * deferred объект. Сообщает о готовности к использованию пространства имен WebAccess.current.objectList после его полной инициализации.
    * @member WebAccess.ObjectListInit
    */
    this.ObjectListInit = $.Deferred();
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    this._DetailsGridInit = $.Deferred();

    /**
    * deferred объект. Сообщает о готовности к использованию пространства имен WebAccess.current.user после после его полной инициализации
    * @since 5.0.0.7200
    * @member WebAccess.UserInfoInit
    */
    this.UserInfoInit = $.Deferred();
    this._userInfoInit = $.Deferred();

   
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Предоставляет инструменты для работы с анимацией, отображающей процесс загрузки.
    *
    * @namespace WebAccess.current.spinner  
    * @since 5.0.0.7300  
    */

    /**
    * Отложенный запуск анимации процесса загрузки.
    *
    * @method WebAccess.current.spinner.showDelayed
    * @param {Integer} [opt_delay] Задержка запуска анимации в миллисекундах
    * @return {WebAccess.current.spinner} Объект типа spinner.
    * @since 5.0.0.7300
    */

    /**
    * Показать анимацию процесса загрузки.
    *
    * @method WebAccess.current.spinner.show
    * @return {WebAccess.current.spinner} Объект типа spinner.
    * @since 5.0.0.7300
    */

    /**
    * Показать анимацию процесса загрузки в диалоговом окне.
    *
    * @method WebAccess.current.spinner.showInDialog
    * @param {Integer} [opt_delay] Задержка запуска анимации в миллисекундах
    * @return {WebAccess.current.spinner} Объект типа spinner.
    * @since 5.0.0.7300
    */

    /**
    * Скрыть анимацию процесса загрузки.
    *
    * @method WebAccess.current.spinner.hide
    * @param {String} [opt_message] Cообщение о завершении процесса загрузки.
    * @param {Integer} [opt_delay] Задержка запуска анимации в миллисекундах
    * @param {Integer} [opt_callback] Функция, которая будет запущена после скрытия анимации.
    * @return {WebAccess.current.spinner} Объект типа spinner.
    * @since 5.0.0.7300
    */



    /**
    * Предоставляет инструменты для работы с диалоговыми сообщениями.
    *
    * @since 5.0.0.7300
    * @namespace WebAccess.current.inlineHint
    */

    /**
    * Показать диалоговое окно с предупреждением.
    *
    * @function  WebAccess.current.inlineHint.showWarning
    * @param {String} message Основной текст предупреждения
    * @param {String} [opt_details] Информационный текст, объясняющий суть предупреждения
    * @return  {WebAccess.current.inlineHint} Объект типа inlineHint.
    * @since 5.0.0.7300
    */

    /**
    * Показать диалоговое окно с текстом ошибки.
    *
    * @function  WebAccess.current.inlineHint.showError
    * @param {String} message Основной текст ошибки
    * @param {String} [opt_details] Информационный текст, объясняющий ошибку
    * @return {WebAccess.current.inlineHint} Объект типа inlineHint.
    */

    /**
    * Показать диалоговое окно с информацией.
    *
    * @function  WebAccess.current.inlineHint.showInfo
    * @param {String} message Основной текст сообщения
    * @param {String} [opt_details] Информационный текст, объясняющий суть сообщения
    * @return {WebAccess.current.inlineHint} Объект типа inlineHint.
    * @since 5.1.0.1511
    */

    /**
    * Показать диалоговое окно сообщения.
    *
    * @function  WebAccess.current.inlineHint.show
    * @param {String} message сОсновной текст сообщения
    * @param {String} [opt_details] Информационный текст
    * @param {MESSAGE_TYPE} [opt_messageType] Тип сообщения
    * @return {WebAccess.current.inlineHint} Объект типа inlineHint.
    */
    
    /**
    * Скрыть последнее открытое сообщение.
    *
    * @function  WebAccess.current.inlineHint.hide        
    * @return {WebAccess.current.inlineHint} Объект типа inlineHint.
    * @since 5.0.0.7300
    */
    
    /**
    * Скрыть все сообщения.
    *
    * @function WebAccess.current.inlineHint.hideAll
    * @static
    * @since 5.0.0.7300
    */

    $.when(this.FormControlsInit).done(function () {
      if (!$('html').hasClass('mobile') && !self.current.inlineHint) {
        self.current.spinner = new WA.CMP.notifications.Spinner();
        self.current.inlineHint = new WA.CMP.notifications.InlineHint();
      }
    });


    /**
    * deferred объект. Сообщает о готовности к использованию пространства имен WebAccess.extensions после его полной инициализации.
    * @member WebAccess.ExtensionsInit
    */
    this.ExtensionsInit = $.Deferred();
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * deferred объект. Сообщает о готовности к использованию дерева объектов
    * @member WebAccess.ExtensionsInit
    * @since 5.2.0.1600
    * @comment документаторы, не акцентируйте на него много внимания, немотря на то, что он новый.
    */
    this.FolderTreeInit = $.Deferred();
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /** @private */
    this._extensionsDataInit = $.Deferred();
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * deferred объект. Сообщает о готовности к использованию пространства имен WebAccess.current.form после его полной инициализации.
    * @member WebAccess.FormInit
    * @since 5.0.0.7100
    */
    this.FormInit = $.Deferred();


    /**
    * Когда объект extensions заполняется данными, дополняем его еще и методами.
    */
    $.when(this._extensionsDataInit).done(function () {
      for (var extension in self.extensions) {
        var ext = new Extension(self.extensions[extension]);
        self.extensions[extension] = ext;
        /**
        * Ссылка на объект типа Extension, который хранит информацию о текущем веб-модуле.
        * @member WebAccess.extensions.current
        */
        if (ext.isCurrent) self.extensions.current = ext;
      }
      self.EXT = self.extensions;
      self.ExtensionsInit.resolve();
    });
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Когда все элементы будут загружены, тогда вызовем все функции иницализации.
    * @fixme вызывать функции асинхронно
    */
    $.when(this.ToolBarInit,
           this.SideBarInit,
           this.FormControlsInit,
           this.DetailsInit,
           this.ExtensionsInit,
           this.ObjectListInit,
           this.FormInit,
           this.UserInfoInit).done(function () {
             self.Init.resolveWith(self);
             self._whenInitComplete.forEach(function (fn) {
               setTimeout(() => {
                 fn.call(self);
               }, 0);
             });
           });
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    $('html').bind(PAGE_EVENTS.TAB_ON_AFTER_RENDER_NEW_MODEL, function () {
      self._whenInitComplete.forEach(function (fn) {
        fn.call(self);
      });
    });

    this.Task = new TaskModel();
    this.Job = new JobModel();
    this.Document = new DocumentModel();
    this.ReferenceRecord = new ReferenceRecordModel();
    this.Folder = new FolderModel();
    this.Wizard = new WizardModel();
    // Добавил для отработки событий "До запроса парраметров" при выборе ТМа.
    this.Events = {};

    /**
    * @ignore
    * @function WebAccess.setEvents
    * @todo кому-нибудь описать что это.
    */
    this.setEvents = function (events) {
      $.each(events, function (key, value) {
        self.Events[key] = value;
      });
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Генерировать исключение.
     * Если при срабатывании исключение не было отловлено конструкцией try/catch или функция
     * не была обернута в функцию tryCatchDecorator, то выполняемый сценарий остановится.
     *
     * @function WebAccess.raise
     * @param {string} error Код строки ошибки
     * @param {string} [value] Переданное значение, например имя объекта, вызвавшего ошибку
     *
     * @example
     * // Проверка существования закладки. Если закладка существует, то генерируется исключение.
     * if (jExistingTab.length > 0) WebAccess.raise("ERR_TAB_WITH_THE_SAME_NAME_ALREADY_EXIST", name);
     */
    this.raise = function (error, value) {
      let message = L(error);

      if (value) {
        message += `: ${value}`;
      }

      const exception = new Error(message);
     
      if (window.log) {
        log.error('DEFAULT', `${message}\n${exception.stack}`);
      }

      exception.name = error;

      // Выбрасываем исключение, чтобы остановить выполняемый сценарий.
      throw exception;    
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//    


    /**
    * Автоматически отобрать исключения, которые могут произойти в функции. 
    * Выводит информацию об исключении в стандартную область ошибок и уведомлений. 
    * Не рекомендуется использовать в местах, где нужна производительность, особенно при работе в циклах.
    *
    * @function WebAccess.tryCatchDecorator
    * @param {function} decoratedFunction декорируемая функция
    * @since 5.0.0.4000 
    * @alias TCD
    *
    * @example
    * function ShowCustomizationWindow(el) {
    *   ...
    *	  // Произошло исключение.
    *   ...
    * };
    * ShowCustomizationWindow = WebAccess.tryCatchDecorator(ShowCustomizationWindow);
    * // В результате выполнения функции, исключение будет обработано, и не остановит дальнейшее выполнение сценария.
    */
    this.tryCatchDecorator = this.TCD = function (decoratedFunction) {
      return function () {
        try {
          return decoratedFunction.apply(this, arguments);
        } catch (err) {
          if (window.log) log.error('DEFAULT', err);
          if (window.console) console.log(err);
          $.when(WA.FormControlsInit).then(() => {
            WA.CMP.NTF.InlineHint.hideAll();
            let message = `${L('JS_ERROR')} :  ${err.message}`;
            WA.CR.inlineHint.showError(message, null, INLINE_HINT_PRIORITY.PRIMARY);
          });
          return null;
        }
      };
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Закешированное текущее местоположение.
    * @private
    * @property WebAccess._location
    */
    this._location = '';
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Определить текущее местоположение.
    *
    * @function WebAccess.getLocation
    * @return {string} Текущее местонахождение, например explorer, task, job, reference, wizard, about.
    * @example 
    * if (WA.getLocation === 'explorer') {
    *   console.log('В данный момент мы находимся в проводнике веб-доступа');
    * };
    */
    this.getLocation = () => {
      if (!this._location) {
        if (!window.location) return '';
        const path = window.location.pathname;
        this._location = path.substr(1, path.lastIndexOf('.') - 1).toLowerCase();
      }
      return this._location;
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показывает, что мобильный веб-доступ открыт.
    *
    * @function WebAccess.isMobile
    * @return {boolean} True – мобильный веб-доступ открыт, иначе False.
    * @since 5.1.0.1505
    */
    this.isMobile = function () {
      return ($("html.mobile").length > 0);
    };

    /**
    * Выйти из проводника веб-доступа.
    *
    * @function WebAccess.logout
    * @return {WebAccess} Объет типа WebAccess.  
    * @since 5.0.0.7300
    */
    this.logout = () => {
      $.cookie('lang', null);

      if (!this.isMobile()) {
        if (WA.agent.isSessionInitialized()) {
          //FIXME: always переделать на done и fail
          WA.agent.isPluginAvailable('edmsplugin')
            .always((isAvailableResponse) => {
              //Сообщаем агенту о выходе
              if (isAvailableResponse) {
                WA.agent.endSession();
              }
            });
        }        
      }

      //Закрываем сессию
      CallService('/Authentication.asmx/Logout', {}, () => window.location = 'Login.aspx');
      return this;
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  window.WebAccess = window.WA = new WebAccess();
})();

